@if (heading()) {
  <div class="w-full pt-6 mb-4 lg:mb-6 px-5 lg:px-12">
    <h2
      [ngClass]="headingClasses"
      [style.color]="categoryNameColor() | contentBuilderColor"
    >
      {{ heading() }}
    </h2>
    @if (description()) {
      <p
        class="mt-1 lg:mt-3 text-sm md:text-base font-base"
        [style.color]="categoryDescriptionColor() | contentBuilderColor"
      >
        {{ description() }}
      </p>
    }
  </div>
}
